var $accfc8e35508e1a4$exports = {};
var $accfc8e35508e1a4$var$burger = document.querySelector(".burger");
var $accfc8e35508e1a4$var$menu = document.querySelector(".menu");
var $accfc8e35508e1a4$var$toggleMenu = function toggleMenu() {
    $accfc8e35508e1a4$var$menu.classList.toggle("is-active");
    $accfc8e35508e1a4$var$burger.classList.toggle("is-active");
};
$accfc8e35508e1a4$var$burger.addEventListener("click", $accfc8e35508e1a4$var$toggleMenu);


//# sourceMappingURL=index.1885d0d3.js.map
